const languages = {
  "ace-ID": "Acehnese",
  "af-ZA": "Afrikaans",
  "ak-GH": "Akan",
  "sq-AL": "Albanian",
  "am-ET": "Amharic",
  "ar-SA": "Arabic",
  "hy-AM": "Armenian",
  "as-IN": "Assamese",
  "ast-ES": "Asturian",
  "awa-IN": "Awadhi",
  "quy-PE": "Ayacucho Quechua",
  "az-AZ": "Azerbaijani",
  "ban-ID": "Balinese",
  "bm-ML": "Bambara",
  "bjn-ID": "Banjar",
  "ba-RU": "Bashkir",
  "eu-ES": "Basque",
  "be-BY": "Belarusian",
  "bem-ZM": "Bemba",
  "bn-BD": "Bengali",
  "bho-IN": "Bhojpuri",
  "bs-BA": "Bosnian",
  "bug-ID": "Buginese",
  "bg-BG": "Bulgarian",
  "my-MM": "Burmese",
  "ca-ES": "Catalan",
  "ceb-PH": "Cebuano",
  "tzm-MA": "Central Atlas Tamazight",
  "ayr-BO": "Central Aymara",
  "knc-NG": "Central Kanuri",
  "hne-IN": "Chhattisgarhi",
  "zh-CN": "Chinese (Simplified)",
  "zh-TW": "Chinese (Traditional)",
  "zh-HK": "Chinese (Traditional, Hong Kong)",
  "cjk-AO": "Chokwe",
  "crh-RU": "Crimean Tatar",
  "hr-HR": "Croatian",
  "cs-CZ": "Czech",
  "da-DK": "Danish",
  "prs-AF": "Dari",
  "diq-TR": "Dimli",
  "dik-SS": "Dinka",
  "nl-NL": "Dutch",
  "nl-BE": "Dutch (Belgium)",
  "dyu-CI": "Dyula",
  "dz-BT": "Dzongkha",
  "en-AU": "English (Australia)",
  "en-CA": "English (Canada)",
  "en-IE": "English (Ireland)",
  "en-GB": "English (United Kingdom)",
  "en-US": "English (United States)",
  "eo-EU": "Esperanto",
  "et-EE": "Estonian",
  "ee-GH": "Ewe",
  "fo-FO": "Faroese",
  "fj-FJ": "Fijian",
  "fil-PH": "Filipino",
  "fi-FI": "Finnish",
  "fon-BJ": "Fon",
  "fr-FR": "French",
  "fr-CA": "French (Canada)",
  "fur-IT": "Friulian",
  "gl-ES": "Galician",
  "ka-GE": "Georgian",
  "de-DE": "German",
  "el-GR": "Greek",
  "gn-PY": "Guaraní",
  "gu-IN": "Gujarati",
  "ht-HT": "Haitian Creole",
  "khk-MN": "Halh Mongolian",
  "ha-NE": "Hausa",
  "he-IL": "Hebrew",
  "hi-IN": "Hindi",
  "hu-HU": "Hungarian",
  "is-IS": "Icelandic",
  "ig-NG": "Igbo",
  "ilo-PH": "Iloko",
  "id-ID": "Indonesian",
  "ga-IE": "Irish",
  "it-IT": "Italian",
  "ja-JP": "Japanese",
  "jv-ID": "Javanese",
  "kac-MM": "Jingpho",
  "kbp-TG": "Kabiyè",
  "kea-CV": "Kabuverdianu",
  "kab-DZ": "Kabyle",
  "kam-KE": "Kamba",
  "kn-IN": "Kannada",
  "kas-IN": "Kashmiri (Arabic script)",
  "ks-IN": "Kashmiri (Devanagari script)",
  "kk-KZ": "Kazakh",
  "km-KH": "Khmer",
  "ki-KE": "Kikuyu",
  "kmb-AO": "Kimbundu",
  "rw-RW": "Kinyarwanda",
  "rn-BI": "Kirundi",
  "kg-CG": "Kongo",
  "ko-KR": "Korean",
  "ckb-IQ": "Kurdish Sorani",
  "ky-KG": "Kyrgyz",
  "lo-LA": "Lao",
  "ltg-LV": "Latgalian",
  "la-VA": "Latin",
  "lv-LV": "Latvian",
  "lij-IT": "Ligurian",
  "li-NL": "Limburgish",
  "ln-CD": "Lingala",
  "lt-LT": "Lithuanian",
  "lmo-IT": "Lombard",
  "lua-CD": "Luba-Lulua",
  "lg-UG": "Luganda",
  "luo-KE": "Luo",
  "lb-LU": "Luxembourgish",
  "mk-MK": "Macedonian",
  "mag-IN": "Magahi",
  "mai-IN": "Maithili",
  "mg-MG": "Malagasy",
  "ms-MY": "Malay",
  "ml-IN": "Malayalam",
  "mt-MT": "Maltese",
  "mni-IN": "Manipuri",
  "mi-NZ": "Maori",
  "mr-IN": "Marathi",
  "min-ID": "Minangkabau",
  "lus-IN": "Mizo",
  "mn-MN": "Mongolian",
  "sr-ME": "Montenegrin",
  "mos-BF": "Mossi",
  "ne-NP": "Nepali",
  "fuv-NG": "Nigerian Fulfulde",
  "kmr-TR": "Northern Kurdish",
  "nso-ZA": "Northern Sotho",
  "nb-NO": "Norwegian Bokmål",
  "nus-SS": "Nuer",
  "ny-MW": "Nyanja",
  "oc-FR": "Occitan",
  "or-IN": "Odia",
  "pag-PH": "Pangasinan",
  "pap-CW": "Papiamento",
  "ps-PK": "Pashto",
  "fa-IR": "Persian",
  "plt-MG": "Plateau Malagasy",
  "pl-PL": "Polish",
  "pt-BR": "Portuguese (Brazil)",
  "pt-PT": "Portuguese (Portugal)",
  "pa-IN": "Punjabi",
  "ro-RO": "Romanian",
  "ru-RU": "Russian",
  "sm-WS": "Samoan",
  "sg-CF": "Sango",
  "sa-IN": "Sanskrit",
  "sat-IN": "Santali",
  "sc-IT": "Sardinian",
  "gd-GB": "Scottish Gaelic",
  "sr-Cyrl-RS": "Serbian (Cyrillic script)",
  "sr-Latn-RS": "Serbian (Latin script)",
  "shn-MM": "Shan",
  "sn-ZW": "Shona",
  "scn-IT": "Sicilian",
  "szl-PL": "Silesian",
  "sd-PK": "Sindhi",
  "si-LK": "Sinhala",
  "sk-SK": "Slovak",
  "sl-SI": "Slovenian",
  "so-SO": "Somali",
  "azb-AZ": "South Azerbaijani",
  "pbt-PK": "Southern Pashto",
  "st-LS": "Southern Sotho",
  "es-ES": "Spanish",
  "es-AR": "Spanish (Argentina)",
  "es-419": "Spanish (Latin America)",
  "es-MX": "Spanish (Mexico)",
  "su-ID": "Sundanese",
  "sw-KE": "Swahili",
  "ss-SZ": "Swati",
  "sv-SE": "Swedish",
  "tl-PH": "Tagalog",
  "tg-TJ": "Tajik",
  "taq-ML": "Tamasheq",
  "ta-IN": "Tamil",
  "tt-RU": "Tatar",
  "te-IN": "Telugu",
  "th-TH": "Thai",
  "bo-CN": "Tibetan",
  "ti-ET": "Tigrinya",
  "tpi-PG": "Tok Pisin",
  "als-AL": "Tosk Albanian",
  "ts-ZA": "Tsonga",
  "tn-ZA": "Tswana",
  "tum-MW": "Tumbuka",
  "tr-TR": "Turkish",
  "tk-TM": "Turkmen",
  "tw-GH": "Twi",
  "uk-UA": "Ukrainian",
  "umb-AO": "Umbundu",
  "ur-PK": "Urdu",
  "ug-CN": "Uyghur",
  "uzn-UZ": "Uzbek",
  "vec-IT": "Venetian",
  "vi-VN": "Vietnamese",
  "war-PH": "Waray",
  "cy-GB": "Welsh",
  "gaz-ET": "West Central Oromo",
  "vls-BE": "West Flemish",
  "wo-SN": "Wolof",
  "xh-ZA": "Xhosa",
  "ydd-US": "Yiddish",
  "yo-NG": "Yoruba",
  "zu-ZA": "Zulu"
};
export default {
  source: languages,
  target: languages
};